var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"d-flex justify-center pa-5"},[_c('div',{staticStyle:{"max-width":"300px","width":"100%"}},[_c('div',{staticClass:"text-coming-soon"},[_vm._v("loading...")]),_c('v-progress-linear',{attrs:{"indeterminate":"","rounded":"","color":"green","height":"7"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }